module.exports = __webpack_public_path__ + "img/SketchPngeccfa8304f163a4468de272dbaae64a310ae525258847e425bddfe1ea60bcc3f.7a7485a0.png";